import { ActListVM } from 'civil-status/view-models/research-form';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<ActListVM, keyof ActListVM>[] = [
  {
    id: 'idAct',
    label: 'ID',
  },
  {
    id: 'subject',
    label: 'Soggetto',
  },
  {
    id: 'registerEmergency',
    label: 'Registro di emergenza',
  },
  {
    id: 'number',
    label: 'Numero',
  },
  {
    id: 'typeAct',
    label: 'Tipologia Atto',
  },
  {
    id: 'date',
    label: 'Data decorrenza',
  },
  {
    id: 'dateLastUpdate',
    label: 'Data ultimo aggiornamento',
  },
  {
    id: 'nameOperator',
    label: 'Ultimo Operatore',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
